var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57677 0.278417L13.7174 6.32784C14.0942 6.69906 14.0942 7.30094 13.7174 7.67216L7.57677 13.7216C7.19995 14.0928 6.589 14.0928 6.21218 13.7216C5.83537 13.3504 5.83537 12.7485 6.21218 12.3773L10.7056 7.95058H0V6.04942H10.7056L6.21218 1.62273C5.83537 1.25151 5.83537 0.64964 6.21218 0.278417C6.589 -0.0928057 7.19995 -0.0928057 7.57677 0.278417Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default ForwardRef;